import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { PaginatedRequest } from '@wajeez-web/core/api';
import { thunkErrorHandler } from '@wajeez-web/core/utils';
export const getAllNarrators: ApiMethod<
  PaginatedRequest,
  Server.NarratorOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_get_V1(
      undefined,
      data.page,
      data.pageSize
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getNarratorByIdMultilingual: ApiMethod<
  number,
  Server.NarratorMultilingualOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Narrators_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_Narrators_multilingualById_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const createNewNarrator: ApiMethod<
  Server.CreateNarratorInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_post_V1(variables);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNarratorMultilingual: ApiMethod<
  Server.CreateNarratorV2Input,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Narrators_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_Narrators_post_V2(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const editNarrator: ApiMethod<
  Server.EditNarratorInput,
  number,
  any
> = async (variables, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_put_V1(variables);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const editNarratorMultilingual: ApiMethod<
  Server.EditNarratorV2Input,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_Narrators_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_Narrators_put_V2(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const deleteNarrator: ApiMethod<number, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDefaultNarrator: ApiMethod<
  string,
  Server.NarratorDashboardOutput,
  any
> = async (contentEntityId, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_defaultByContentEntityId_get_V1(
      contentEntityId
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getNarratorsAsDataTable: ApiMethod<
  Server.NarratorDatatable,
  Server.TableOfNarratorColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_datatable_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getNarratorsLookUps: ApiMethod<
  string,
  Server.NarratorLookUpOutput[],
  any
> = async (searchString, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Narrators_Client(undefined, contentClient);
    const response = await client.narrators_lookups_get_V1(
      undefined,
      searchString
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
